import { Network } from "../../.."
import store from "../../../../store"

class EmployerInvoiceAttributes {
	constructor(attributes) {
		Object.assign(this, attributes)
	}
}

export const STRIPE_STATUS = {
	DRAFT: "draft",
	OPEN: "open",
	ACCEPTED: "accepted",
	CANCELED: "canceled"
}

export default class EmployerInvoice extends EmployerInvoiceAttributes {
	static async getAllEmployers({}) {
		const [
			{
				data: { data: billingData }
			}
		] = await Promise.all([
			Network.AxiosWrapperV2.get({
				url: `employer/@all/billing/invoice`
			})
		])

		const invoiceMap = new Map()
		billingData.forEach((d) => {
			invoiceMap.set(
				d.id,
				new EmployerInvoice({
					...d
				})
			)
		})

		return invoiceMap
	}

	static async getAll({ params: { employer } }) {
		const [
			{
				data: { data: billingData }
			}
		] = await Promise.all([
			Network.AxiosWrapperV2.get({
				url: `employer/${employer.id || "@all"}/billing/invoice`
			})
		])

		const invoiceMap = new Map()
		billingData.forEach((d) => {
			invoiceMap.set(
				d.id,
				new EmployerInvoice({
					...d
				})
			)
		})

		return invoiceMap
	}

	static async createOne({ params, payload }) {
		try {
			const { data: billingData } = await Network.AxiosWrapperV2.post({
				url: `employer/${params.employerId}/billing/invoice`
			})

			await store.setNotification("notification", true, {
				msg: `Successfully charged this employer.`,
				severity: "success",
				isPersist: true
			})
		} catch (err) {
			console.error(err)
		}
	}
}
